import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-order-bank-transaction-dialog',
  templateUrl: './order-bank-transaction-dialog.component.html',
  styleUrls: ['./order-bank-transaction-dialog.component.scss']
})
export class OrderBankTransactionDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<OrderBankTransactionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    }

  ngOnInit() {
  }

}
